/**
 * Constants related to post-session safeguarding analysis of recordings
 */

/**
 * The only `itemSeverity` values the safeguarding prompt may return.
 * Anything else means the model went off-contract: see `toAlertPriority`,
 * which maps these to an alert priority and rejects everything else.
 */
export enum ItemSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}
